import AddBoxIcon from '@mui/icons-material/AddBox'
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox'
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied'
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied'
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied'
import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import StarHalfIcon from '@mui/icons-material/StarHalf'
import ThumbDownIcon from '@mui/icons-material/ThumbDown'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'

export const icons = {
  thumbs: [ThumbDownIcon, ThumbUpIcon],
  faces: [SentimentVeryDissatisfiedIcon, SentimentSatisfiedIcon, SentimentVerySatisfiedIcon],
  stars: [StarBorderIcon, StarHalfIcon, StarIcon],
  nps: [IndeterminateCheckBoxIcon, AddBoxIcon],
}

export const defaultLabels = {
  thumbs: ['Disapprove', 'Approve'],
  faces: ['Not well', 'Neutral', 'Good'],
  nps: ['Not at all likely', 'Extremely likely'],
}
